import { ConfigProvider, Table } from 'antd'
import { FC, useEffect, useState } from 'react'
import { useNavigate } from 'react-router-dom'
import ruRU from 'antd/lib/locale/ru_RU'
import Filter from '../Filter/Filter'
import { CenteredSpin } from '../../../ui'
import style from './style.m.less'
import useMount from '../../../hooks/useMount'
import { getAdminRegistry, getTypesDict } from '../../config'
import { renderDate } from '../../../../utils/formatter'
import { currencyFormat } from '../../../helpers'

import useRequest from '../../../hooks/useRequest'

interface IDefault {
    filters: any
    setFilters: any
}

type PaginationType = {
    page: number
    pageSize: number
    filters?: any
}

const PAGE_SIZE = 10

const DEFAULT_PAG = {
    page: 1,
    pageSize: PAGE_SIZE,
}

const COLUMNS = (dict: any) => [
    {
        title: 'Дата и время',
        dataIndex: 'ts_event',
        key: 'ts_event',
        render: (date: Date) => renderDate(date),
    },
    {
        title: 'Тип операции',
        dataIndex: 'type_event_id',
        key: 'type_event_id',
        render: (type: number) => {
            const found = dict.find((item: any) => item.id === type)
            return found.name
        },
    },
    {
        title: 'Пополнение',
        dataIndex: 'payload',
        key: 'refill',
        render: (payload: any) =>
            payload?.operation_type_id === 2
                ? payload?.amount
                    ? `+ ${currencyFormat(Number(payload?.amount).toFixed(2))} ₽`
                    : '-'
                : '-',
    },
    {
        title: 'Списание',
        dataIndex: 'payload',
        key: 'writeOff',
        render: (payload: any) =>
            payload?.operation_type_id === 1
                ? payload?.amount
                    ? `- ${currencyFormat(Number(payload?.amount).toFixed(2))} ₽`
                    : '-'
                : '-',
    },
    {
        title: 'Пользователь',
        dataIndex: 'name_recipient',
        key: 'name_recipient',
    },
]

const Default: FC<IDefault> = ({ filters, setFilters }) => {
    const [pagination, setPagination] = useState<PaginationType>(DEFAULT_PAG)
    const { fetch: fetchDict, result: dict, isLoading: isLoadingDict } = useRequest(getTypesDict)
    const { fetch, result, isLoading } = useRequest(getAdminRegistry)

    const getData = ({ page = 1, pageSize = 10, filters }: PaginationType) => {
        fetch({
            body: {
                limit: pageSize,
                offset: (page - 1) * pageSize,
                filters,
            },
        })
    }

    useMount(() => {
        fetchDict({})
    })

    useEffect(() => {
        if (!dict) {
            return
        }
        getData({ ...DEFAULT_PAG, filters })
    }, [dict])

    const updateFilters = (data: string | number | boolean, key: string, obj?: any) => {
        const updatedFilter = {
            ...filters,
            ...(obj ? { ...obj } : { [key]: data }),
        }
        setFilters(updatedFilter)
        setPagination({ page: 1, pageSize: pagination.pageSize })
        getData({ page: 1, pageSize: pagination.pageSize, filters: updatedFilter })
    }

    if (isLoadingDict || !dict) {
        return <CenteredSpin />
    }

    return (
        <div className={style.opened}>
            <Filter onChange={updateFilters} dict={dict} filters={filters} />
            <div className={style.table}>
                <ConfigProvider locale={ruRU}>
                    <Table
                        dataSource={result?.events || []}
                        columns={COLUMNS(dict)}
                        rowClassName={(record) => (record.has_update ? style.rowBold : '')}
                        pagination={{
                            position: ['bottomLeft'],
                            onChange: (page, pageSize) => {
                                getData({ page, pageSize, filters })
                                setPagination({ page, pageSize })
                            },
                            total: result?.total,
                            current: pagination.page,
                            pageSize: pagination.pageSize,
                            showSizeChanger: true,
                        }}
                        loading={isLoading}
                    />
                </ConfigProvider>
            </div>
        </div>
    )
}

export default Default
